import { BrowserModule, DomSanitizer, HammerModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthTokenInterceptor } from 'routes/interceptor';
import { JFlexLayoutModule } from 'modules/flex-layout/flex-layout.module';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { NgIdleModule } from 'src/libs/ng-idle/module';
import {
    ConfirmationDialogModule,
    CountdownDialogModule,
    MessageBoxDialogModule,
    SplashDialogModule,
} from '@polk_county_public_schools/ngx-pcps-dialogs';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';

// Application Modules
import { PhonePipeModule } from 'modules/pipes';
import { RoleTextPipeModule } from 'pipes/roletext';

import { AppComponent } from './components/app/app.component';
import { AppRoutingModule } from 'routes/app.routing.module';
import { AuthenticatedGuard, UnsavedChangesGuard, UnsavedChangesService } from 'routes/routes.guard';

// UI Components
import { NavMenuComponent } from './components/navmenu/navmenu.component';
import { UserHeaderComponent } from './components/user-header/user-header.component';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
    override events = ['doubleTap'];
    // overrides = {
    //     swipe: { direction: Hammer.DIRECTION_ALL },
    //     tap: { event: 'doubleTap', taps: 2 },
    //     // tslint:disable-next-line: no-any
    // } as any;
}

@NgModule({
    declarations: [
        AppComponent,

        // UI components
        NavMenuComponent,
        UserHeaderComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HammerModule,
        HttpClientModule,
        JFlexLayoutModule,
        NgxWebstorageModule.forRoot(),
        NgIdleModule.forRoot(),

        MatButtonModule,
        MatIconModule,
        MatSidenavModule,
        MatTooltipModule,

        ConfirmationDialogModule,
        CountdownDialogModule,
        MessageBoxDialogModule,
        SplashDialogModule,

        // Application module imports
        AppRoutingModule,

        PhonePipeModule,
        RoleTextPipeModule,
    ],
    providers: [
        AuthenticatedGuard,
        UnsavedChangesGuard,
        UnsavedChangesService,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true,
        },
        DatePipe,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
        this.iconRegistry.addSvgIcon('custompdf', this.sanitizer.bypassSecurityTrustResourceUrl('file-pdf-box.svg'));
    }
}
